import { render, staticRenderFns } from "./CustomersFilesUploader.vue?vue&type=template&id=71f64b84&scoped=true&"
import script from "./CustomersFilesUploader.vue?vue&type=script&lang=js&"
export * from "./CustomersFilesUploader.vue?vue&type=script&lang=js&"
import style0 from "./CustomersFilesUploader.vue?vue&type=style&index=0&id=71f64b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f64b84",
  null
  
)

export default component.exports